import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  BillingProcess,
  BillingProcessInvoiceDraft,
  BillingProcessInvoicePreview,
} from 'src/app/models/billing-process';
import { BillingProcessService } from 'src/app/services/billing-process.service';
import { MessageUtil } from 'src/app/utils/message.util';

@Component({
  selector: 'app-wizard-step-invoice-preview',
  templateUrl: './wizard-step-invoice-preview.component.html',
  styleUrls: ['./wizard-step-invoice-preview.component.scss'],
})
export class WizardStepInvoicePreviewComponent implements OnInit {
  @Input() process: BillingProcess;
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  preview: BillingProcessInvoicePreview | null = null;
  loading = false;
  expandedInvoiceId: string | null = null;
  tableExpanded = false;

  constructor(
    private billingProcessService: BillingProcessService,
    private spinner: NgxSpinnerService,
    private messageService: MessageUtil,
  ) {}

  ngOnInit(): void { this.load(); }

  load(): void {
    this.loading = true;
    this.spinner.show();
    this.billingProcessService.invoicePreview(this.process.id).subscribe({
      next: (preview) => {
        this.preview = preview;
        this.spinner.hide();
        this.loading = false;
      },
      error: (err) => {
        this.spinner.hide();
        this.loading = false;
        this.messageService.generateMessage(
          'error', 'SUMMARY.ERROR',
          err?.error?.message ?? 'Erro ao calcular preview de faturas.');
      },
    });
  }

  toggleInvoice(invoice: BillingProcessInvoiceDraft): void {
    const key = this.invoiceKey(invoice);
    this.expandedInvoiceId = this.expandedInvoiceId === key ? null : key;
  }

  isExpanded(invoice: BillingProcessInvoiceDraft): boolean {
    return this.expandedInvoiceId === this.invoiceKey(invoice);
  }

  invoiceKey(invoice: BillingProcessInvoiceDraft): string {
    return `${invoice.customerId}:${invoice.billingCompanyId ?? 'main'}`;
  }

  get hasInvoices(): boolean {
    return !!this.preview && (this.preview.totalInvoices || 0) > 0;
  }

  get largestInvoice(): BillingProcessInvoiceDraft | null {
    if (!this.preview) return null;
    return this.preview.invoices.reduce<BillingProcessInvoiceDraft | null>((max, i) =>
      !max || i.totalValue > max.totalValue ? i : max, null);
  }

  get averageInvoice(): number {
    if (!this.preview || !this.preview.totalInvoices) return 0;
    return (this.preview.totalValue || 0) / this.preview.totalInvoices;
  }

  sourceLabel(sourceType: string): string {
    switch (sourceType) {
      case 'BOAT_SERVICE': return 'Mensalidade barco';
      case 'CUSTOMER_SERVICE': return 'Serviço cliente';
      case 'FRANCHISE': return 'Franquia';
      case 'EXISTING_ORDER': return 'Pedido avulso';
      default: return sourceType;
    }
  }
}
